/// <reference path='interfaces/interfaces.d.ts' />
import functions = require('./global/functions');

import {IStateService} from 'angular-ui-router';

import IInjectorService = angular.auto.IInjectorService;
import VERSIONS = require('./version');

declare global {
    interface Window {
        LiveChatWidget: any
    }
}

module Beneple {
    'use strict';
    let  cacheBustVersion = Date.now();


    var config: any = ($httpProvider: ng.IHttpService,
                       $stateProvider: ng.ui.IStateProvider,
                       $urlRouterProvider: ng.ui.IUrlRouterProvider,
                       $qProvider: ng.IQProvider,
                       $mdThemingProvider: angular.material.IThemingProvider,
                       $mdDateLocaleProvider: angular.material.IDateLocaleProvider,
                       $compileProvider: angular.ICompileProvider,
                       $provide: angular.auto.IProvideService) => {

        $httpProvider.defaults.xsrfCookieName = 'csrftoken';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
        $httpProvider.defaults.withCredentials = true;
        $compileProvider.debugInfoEnabled(false);

        $provide.decorator("$http", ["$delegate", function($delegate) {
            $delegate.defaults.headers.common['VX-Version'] = VERSIONS.APP_VERSION;

            var get = $delegate.get;
            $delegate.get = function(url, config) {
                // Only append cache busting version to app html templates
                if (url && url.startsWith('/static/templates/') && url.endsWith('.html')) {
                    // Append ?v=[cacheBustVersion] to url
                    url += (url.indexOf("?") === -1 ? "?" : "&");
                    url += "v=" + cacheBustVersion;
                }
                return get(url, config);
            };
            return $delegate;
        }]);

        $mdDateLocaleProvider.formatDate = function(date) {
            var m = moment(date);
            return m.isValid() ? m.format('D MMMM YYYY') : '';
        }; 

        $qProvider.errorOnUnhandledRejections(false);
        // define palettes here to use accross ui elements
        // primary palette: colors most widely used across all screens and components
        $mdThemingProvider.definePalette('benepleprimary', {
            '50': 'e4ebf1',
            '100': 'bcccdd',
            '200': '8faac7',
            '300': '6288b0',
            '400': '406f9f',
            '500': '1e558e',
            '600': '1a4e86',
            '700': '16447b',
            '800': '123b71',
            '900': '0a2a5f',
            'A100': '92b6ff',
            'A200': '5f94ff',
            'A400': '2c72ff',
            'A700': '1360ff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
              '50',
              '100',
              '200',
              '300',
              'A100',
              'A200'
            ],
            'contrastLightColors': [
              '400',
              '500',
              '600',
              '700',
              '800',
              '900',
              'A400',
              'A700'
            ]
        });
        // accent palette: colors used for the floating action button and interactive elements.
        $mdThemingProvider.definePalette('benepleaccent', {
            '50': 'fef9e8',
            '100': 'fcefc6',
            '200': 'fbe4a0',
            '300': 'f9d97a',
            '400': 'f7d15e',
            '500': 'f6c941',
            '600': 'f5c33b',
            '700': 'f3bc32',
            '800': 'f2b52a',
            '900': 'efa91c',
            'A100': 'ffffff',
            'A200': 'ffd34e',
            'A400': 'ffe8be',
            'A700': 'ffdea4',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
              '50',
              '100',
              '200',
              '300',
              '400',
              '500',
              '600',
              '700',
              '800',
              '900',
              'A100',
              'A200',
              'A400',
              'A700'
            ],
            'contrastLightColors': []
        });

        $mdThemingProvider.definePalette('beneplewarn', {
            '50': 'faeeee',
            '100': 'f3d4d6',
            '200': 'ebb7ba',
            '300': 'e29a9e',
            '400': 'dc848a',
            '500': 'd66e75',
            '600': 'd1666d',
            '700': 'cc5b62',
            '800': 'c65158',
            '900': 'bc3f45',
            'A100': 'ffffff',
            'A200': 'ffdadb',
            'A400': 'ffa7ab',
            'A700': 'ff8d92',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
              '50',
              '100',
              '200',
              '300',
              '400',
              '500',
              '600',
              'A100',
              'A200',
              'A400',
              'A700'
            ],
            'contrastLightColors': [
              '700',
              '800',
              '900'
            ]
        });

        
        $mdThemingProvider.theme('default')
            .primaryPalette('benepleprimary')
            .accentPalette('benepleaccent')
            .warnPalette('beneplewarn');

        $urlRouterProvider.rule(function($injector, $location) {
            let absUrl = $location.absUrl();
            let old_url_suffix = '/#!#%2Fregister';

            if (absUrl.substr(-old_url_suffix.length) === old_url_suffix) {
                return '/register/'
            }
        });

        $urlRouterProvider.otherwise(($injector: IInjectorService, $location) => {
            var $state: any = $injector.get('$state');
            $state.go('root.home');
        });
        $stateProvider
            .state('root', {
                abstract: true,
                views: {
                    'rootView': {
                        templateUrl: '/static/templates/index.html',
                    }
                }
            })
            .state('root.home', {
                url: '/me',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/home.html',
                        controller: 'HomeController',
                        controllerAs: 'C'
                    }
                },
                data: {
                    displayName: 'Home',
                    showBreadcrumbs: false,
                },
                params: {
                    fromSource: ''
                }
            })
            .state('tour', {
                url: '/tour',
                views: {
                    'rootView': {
                        controller: 'TourController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/tour.html',
                    }
                }
            })
            .state('root.benefits', {
                url: '/benefits',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/benefits.html',
                        controller: 'BenefitController',
                        controllerAs: 'C'
                    }
                },
                data: {
                    displayName: 'Benefits',
                    showBreadcrumbs: false
                }
            })
            .state('root.reports', {
                url: '/reports',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/report/reports.html',
                        controller: 'ReportController',
                        controllerAs: 'C'
                    }
                },
                data: {
                    displayName: 'Reports',
                    showBreadcrumbs: false
                }
            })
            .state('root.reports.turnover', {
                url: '/reports/turnover',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/report/turnover.html',
                        controller: 'TurnoverReportController',
                        controllerAs: 'C'
                    }
                },
                data: {
                    displayName: 'Retention Report',
                    showBreadcrumbs: true
                }
            })
            .state('root.reports.gratuity', {
                url: '/reports/gratuity',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/report/gratuity.html',
                        controller: 'GratuityReportController',
                        controllerAs: 'C'
                    }
                },
                data: {
                    displayName: 'Gratuity Report',
                    showBreadcrumbs: true
                }
            })
            .state('root.reports.salary', {
                url: '/reports/salary',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/report/salary.html',
                        controller: 'SalaryReportController',
                        controllerAs: 'C'
                    }
                },
                data: {
                    displayName: 'Salary Report',
                    showBreadcrumbs: true
                }
            })
            .state('root.reports.leave', {
                url: '/reports/leave',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/report/leave.html',
                        controller: 'LeaveReportController',
                        controllerAs: 'C'
                    }
                },
                data: {
                    displayName: 'Leave Report',
                    showBreadcrumbs: true
                }
            })
            .state('root.reports.custom', {
                url: '/reports/custom',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/report/custom.html?v=202105250943',
                        controller: 'CustomReportController',
                        controllerAs: 'C'
                    }
                },
                data: {
                    displayName: 'Custom Report',
                    showBreadcrumbs: true
                }
            })
            .state('root.benefits.manage-insurance', {
                url: '/benefits/manage-insurance',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/benefits-manage-insurance.html',
                        controller: 'BenefitManageInsuranceController',
                        controllerAs: 'C'
                    }
                },
                data: {
                    displayName: 'Benefits',
                    showBreadcrumbs: false
                }
            })
            .state('login', {
                url: '/login',
                views: {
                    'rootView': {
                        controller: 'LoginController',
                        controllerAs: 'login',
                        templateUrl: '/static/templates/login.html',
                    }
                }
            })
            .state('login_mfa', {
                url: '/login_mfa',
                views: {
                    'rootView': {
                        controller: 'LoginMFAController',
                        controllerAs: 'login',
                        templateUrl: '/static/templates/login_mfa.html',
                    }
                },
                params: {
                    username: '',
                    password: ''
                }
            })
            .state('tos', {
                url: '/tos',
                views: {
                    'rootView': {
                        controller: 'TosController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/tos.html',
                    }
                }
            })
            .state('wizard', {
                url: '/wizard',
                views: {
                    'rootView': {
                        controller: 'WizardController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/wizard/wizard.html',
                    }
                }
            })
            .state('register', {
                url: '/register/:sales_person?hrm_email',
                views: {
                    'rootView': {
                        controller: 'RegisterController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/register/register.html',
                    }
                }
            })
            .state('priv', {
                url: '/priv',
                views: {
                    'rootView': {
                        controller: 'PrivController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/priv.html',
                    }
                }
            })
            .state('root.tutorials', {
                url: '/tutorials',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/tutorials.html',
                        controller: 'TutorialsController',
                        controllerAs: 'C'
                    }
                },
                data: {
                    displayName: 'Knowledge Base',
                    showBreadcrumbs: false
                }
            })
            .state('root.org', {
                url: '/org',
                views: {
                    'content@root': {
                        controller: 'OrganisationDetailController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/organization/org_details.html',
                    }
                },
                data: {
                    displayName: 'Settings',
                    showBreadcrumbs: false
                },
                params: {
                    first: false
                }
            })
            .state('root.assets', {
                url: '/assets',
                views: {
                    'content@root': {
                        controller: 'AssetManagerController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/assets/assets_manager.html',
                    }
                },
                data: {
                    displayName: 'Assets',
                    showBreadcrumbs: false
                },
                params: {
                    first: false
                }
            })
            .state('root.org_first', {
                url: '/org/first',
                views: {
                    'content@root': {
                        controller: 'OrganisationDetailController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/organization/org_details.html',
                    }
                },
                data: {
                    displayName: 'Organisation',
                    showBreadcrumbs: true,
                    hideSideBar: true
                },
                params: {
                    first: true
                }
            })
            .state('root.announcements', {
                url: '/announcements',
                views: {
                    'content@root': {
                        controller: 'AnnouncementListController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/announcement/announcement_list.html',
                    }
                },
                data: {
                    displayName: 'Notifications'
                }
            })
            .state('root.uploads', {
                url: '/uploads',
                views: {
                    'content@root': {
                        controller: 'UploadListController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/upload/upload_list.html',
                    }
                },
                data: {
                    displayName: 'Files'
                }
            })
            .state('root.uploads.upload', {
                url: '/upload',
                views: {
                    'content@root': {
                        controller: 'UploadUploadController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/upload/upload_upload.html',
                    }
                },
                data: {
                    displayName: 'Upload file',
                    showBreadcrumbs: true
                }
            })
            .state('root.processes', {
                url: '/processes',
                views: {
                    'content@root': {
                        controller: 'ProcessListController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/process/process_list.html',
                    }
                },
                data: {
                    displayName: 'Requests'
                }
            })
            .state('root.processes.detail', {
                url: '/:id/view',
                views: {
                    'content@root': {
                        controller: 'ProcessDetailController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/process/process_detail.html',
                    }
                },
                data: {
                    displayName: 'Details'
                }
            })
            .state('root.processes.edit', {
                url: '/:id/edit',
                views: {
                    'content@root': {
                        controller: 'ProcessEditController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/process/process_edit.html',
                    }
                },
                data: {
                    displayName: 'Edit request'
                }
            })
            .state('root.processes.create', {
                url: '/create/:type?employee_id',
                views: {
                    'content@root': {
                        controller: 'ProcessCreateController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/process/process_create.html',
                    }
                },
                params: {
                    data: {
                        value: {}
                    }
                },
                data: {
                    displayName: 'Make a new request',
                    showBreadcrumbs: true
                }
            })
            .state('root.processes.export', {
                url: '/export/:type?',
                views: {
                    'content@root': {
                        controller: 'ProcessExportController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/process/process_export.html',
                    }
                },
                params: {
                    data: {
                        value: {}
                    }
                },
                data: {
                    displayName: 'Export request data',
                    showBreadcrumbs: true
                }
            })
            .state('root.processes.archivedLeave', {
                url: '/archived/:type?employee_id',
                views: {
                    'content@root': {
                        controller: 'ProcessListController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/process/archived_leave.html',
                    }
                },
                params: {
                    data: {
                        value: {}
                    }
                },
                data: {
                    displayName: 'Archived Leave Requests',
                    showBreadcrumbs: true
                }
            })
            .state('root.employees', {
                url: '/employees',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/employee/employee_list.html',
                        controller: 'EmployeeListController',
                        controllerAs: 'C',
                    }
                },
                data: {
                    displayName: 'Employees'
                }
            })
            .state('root.employees.import', {
                url: '/import',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/employee/employee_import.html?202105090600',
                        controller: 'EmployeeImportController',
                        controllerAs: 'C',
                    }
                },
                data: {
                    displayName: 'Import Employees',
                    showBreadcrumbs: true
                }
            })
            .state('root.employees.new', {
                url: '/new',
                params: {
                    superior: null
                },
                views: {
                    'content@root': {
                        controller: 'EmployeeNewController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/employee/employee_new.html'
                    }
                },
                data: {
                    displayName: 'Add Employee',
                    showBreadcrumbs: true,
                    hideSideBar: true
                }
            })
            .state('admin.orgs.detail.new', {
                url: '/new/:role',
                views: {
                    'content@admin': {
                        controller: 'EmployeeNewController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/employee/employee_new.html'
                    }
                }
            })
            .state('root.employees.details', {
                url: '/:id',
                views: {
                    'content@root': {
                        controller: 'EmployeeDetailController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/employee/employee_detail.html'
                    }
                },
                data: {
                    displayName: 'Details',
                    showBreadcrumbs: true,
                }
            })
            .state('root.employees.details.calendar', {
                url: '/calendar',
                views: {
                    'content@root': {
                        controller: 'SubordinateCalendarController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/calendar/index.html'
                    }
                },
                data: {
                    displayName: 'Calendar',
                    showBreadcrumbs: true,
                }
            })
            .state('root.employees.details.calendar.add', {
                url: '/add',
                params: {
                    tempEvent: {}
                },
                views: {
                    'content@root': {
                        controller: 'NewEventController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/calendar/add_full_event.html'
                    }
                },
                data: {
                    displayName: 'Add an event',
                    showBreadcrumbs: true,
                }
            })
            .state('root.employees.details.calendar.edit', {
                url: '/:calendar_type/:event_id/edit',
                views: {
                    'content@root': {
                        controller: 'EditEventController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/calendar/edit_full_event.html'
                    }
                },
                data: {
                    displayName: 'Edit event',
                    showBreadcrumbs: true,
                }
            })
            .state('root.employees.details.delete', {
                url: '/delete',
                views: {
                    'content@root': {
                        controller: 'EmployeeTerminateController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/employee/employee_terminate.html'
                    }
                },
                data: {
                    displayName: 'Delete Employee',
                    showBreadcrumbs: true,
                }
            })
            .state('root.employees.details.history', {
                url: '/history',
                views: {
                    'content@root': {
                        controller: 'EmployeeHistoryController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/employee/employee_history.html'
                    }
                },
                data: {
                    displayName: 'History',
                    showBreadcrumbs: true,
                }
            })
            .state('root.health', {
                url: '/safeHands',
                views: {
                    'content@root': {
                        controller: 'TutorialsController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/safeHands/index.html'
                    }
                },
                data: {
                    displayName: 'Health & Wellness',
                    showBreadcrumbs: false
                }
            })
            .state('root.finsbury', {
                url: '/finsbury',
                views: {
                    'content@root': {
                        controller: 'TutorialsController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/finsbury/index.html'
                    }
                },
                data: {
                    displayName: 'Finsbury Associates',
                    showBreadcrumbs: false
                }
            })
            .state('root.searchie', {
                url: '/searchie',
                views: {
                    'content@root': {
                        controller: 'TutorialsController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/searchie.html'
                    }
                },
                data: {
                    displayName: 'Searchie.ai',
                    showBreadcrumbs: false
                }
            })
            .state('root.calendar', {
                url: '/calendar',
                views: {
                    'content@root': {
                        controller: 'PrivateCalendarController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/calendar/index.html'
                    }
                },
                data: {
                    displayName: 'My Calendar',
                    showBreadcrumbs: false
                }
            })
            .state('root.calendar.add', {
                url: '/add',
                params: {
                    tempEvent: {}
                },
                views: {
                    'content@root': {
                        controller: 'NewEventController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/calendar/add_full_event.html'
                    }
                },
                data: {
                    displayName: 'Add an event',
                    showBreadcrumbs: true,
                }
            })
            .state('root.calendar.edit', {
                url: '/:calendar_type/:event_id/edit',
                views: {
                    'content@root': {
                        controller: 'EditEventController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/calendar/edit_full_event.html'
                    }
                },
                data: {
                    displayName: 'Edit event',
                    showBreadcrumbs: true,
                }
            })
            .state('admin', {
                abstract: true,
                views: {
                    'rootView': {
                        templateUrl: '/static/templates/index.html',
                    }
                }
            })
            .state('admin.orgs', {
                url: '/admin/orgs',
                views: {
                    'content@admin': {
                        templateUrl: '/static/templates/admin/admin.html',
                        controller: 'OrgListController',
                        controllerAs: 'C'
                    }
                },
                data: {
                    displayName: 'Support Dashboard',
                    showBreadcrumbs: true,
                    isAdminHomeView: true,
                    hideSideBar: true
                },
                params: {
                    from: ''
                }
            })
            .state('admin.orgs.detail', {
                url: '/:id',
                views: {
                    'content@admin': {
                        controller: 'OrganisationDetailController',
                        controllerAs: 'C',
                        templateUrl: '/static/templates/organization/org_details.html'
                    }
                },
                data: {
                    displayName: 'Details',
                    showBreadcrumbs: true,
                    hideSideBar: true
                }
            })
            .state('deployment', {
                url: '/deployment',
                views: {
                    'rootView': {
                        templateUrl: '/static/templates/deployment.html'
                    }
                }
            })
            // TEMPORARY urls for error pages
            .state('root.error-404', {
                url: '/error-404',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/404.html',
                    }
                }
            })
            .state('root.error-500', {
                url: '/error-500',
                views: {
                    'content@root': {
                        templateUrl: '/static/templates/500.html',
                    }
                }
            })
        // END OF TEMPORARY
    };

    config.$inject = ['$httpProvider', '$stateProvider', '$urlRouterProvider', '$qProvider', '$mdThemingProvider', '$mdDateLocaleProvider', '$compileProvider', '$provide'];

    var run: any = ($http: ng.IHttpService,
                    $rootScope: ng.IRootScopeService,
                    $state: IStateService,
                    $location: any,
                    $window: any,
                    bsLoadingOverlayService: IBsLoadingService,
                    User: any,
                    Org: IOrgsService,
                    Api: Restangular.IService) => {
        bsLoadingOverlayService.setGlobalConfig({
            delay: 500,
            activeClass: 'relative_elem',
            templateUrl: 'overlay-template.html'
        });


        // Amplitude initialisation
        // $http.get('/api/amplitude_key').then((response) => {
        //     var amplitude_key: string = response.data["amplitude_key"]
        //     var amplitude: any = $window.amplitude.getInstance();
        //     amplitude.init(amplitude_key);
        // })

        // Lightweight event-logging
        let eventSessionId: string = Math.random().toString(36).substring(7);;

        // UI state to event mapping
        let stateEventMap = {
            'root.home': 'home',
            'root.announcements': 'notification_board',
            'root.assets': 'assets',
            'root.benefits.manage-insurance': 'insurance',
            'root.employees': 'employee',
            'root.calendar': 'calendar',
            'root.processes': 'requests',
            'root.uploads': 'files',
            'root.reports': 'reports',
            'root.tutorials': 'knowledge_base',
            'root.health': 'health',
        };
        // Handle event and log to the server
        $rootScope.$on('$EL', (event: any, eventName: string, eventAddData?: string) => {

            // Don't log events if superuser
            let isSuperUser = false;
            if (User.getCurrentUser().userData.user) {
                isSuperUser = User.getCurrentUser().userData.user.is_superuser;
            }
            if (isSuperUser) {
                return;
            }

            let superuserMask = User.getCurrentUser().userData.superuser_mask;

            // Collect event data
            if (eventAddData === undefined) {
                eventAddData = ''
            }

            let eventData = {
                eventSessionId: eventSessionId,
                eventName: eventName,
                eventData: eventAddData,
                clientTime: moment(),
                sum: superuserMask
            };

            // Send the event to the server
            Api.restangularizeElement(undefined, eventData, 'eventlog').save();
        });

        // Google Analytics
        $window.ga('create', 'UA-67848530-1', 'auto');

        $rootScope.$on('$stateChangeSuccess', (e: any) => {
            $window.ga('send', 'pageview', $location.path());
        });

        $rootScope.$on('$stateChangeStart', (e: any, toState: any, toParams: any) => {
            // See if we can process the event
            if (stateEventMap.hasOwnProperty(toState.name)) {
                $rootScope.$emit('$EL', stateEventMap[toState.name]);
            }

            // Process state change
            if (toState.name === 'register') {
                    return
            }
            else if (toState.name !== 'login' && toState.name !== 'login_mfa') {
                if (!User.isAuth()) {
                    e.preventDefault();
                    User.loadUser().then(() => {
                        if (User.isAuth() && !User.getCurrentUser().isSuperUser) {
                            Org.getOrgFromCache(org => {
                            });
                            $state.go(toState.name, toParams);
                        } else {
                            $state.go('login');
                        }
                    }, () => {
                        $state.go('login');
                    });
                } else {
                    if (User.getCurrentUser().isSuperUser
                        && (toState.name.indexOf('admin') != 0)) {
                        e.preventDefault();
                        $state.go('admin.orgs');
                    } else {
                        if ((new RegExp('^' + ['root.org', 'root.benefits', 'root.reports'].join("|")).test(toState.name)) && !User.hasPermission('org.view_org')) {
                            e.preventDefault();
                            $state.go('root.home');
                        } else {
                            return
                        }
                    }
                }
            }
        });

    };

    run.$inject = ['$http', '$rootScope', '$state', '$location', '$window', 'bsLoadingOverlayService', 'User', 'Orgs', 'Api'];

    var deps: string[] = [
        'beneple.announcement',
        'beneple.assets',
        'beneple.calendar',
        'beneple.employees',
        'beneple.global',
        'beneple.orgs',
        'beneple.process',
        'beneple.upload',
        'beneple.admin',

        'angucomplete-alt',
        'bsLoadingOverlay',
        'chart.js',
        'checklist-model',
        'lr.upload',
        'ngAnimate',
        'ngMessages',
        'ngFileUpload',
        'ngResource',
        'ngSanitize',
        'ngMaterial',
        'restangular',
        'schemaForm',
        'toaster',
        'ui.bootstrap',
        'ui.calendar',
        'ui.router'
    ];
    angular.module('benepleApp',['ui']).config(["$provide", function($provide) {
        return $provide.decorator("$http", ["$delegate", function($delegate) {
            var get = $delegate.get;
            $delegate.get = function(url, config) {
                // Check is to avoid breaking AngularUI ui-bootstrap-tpls.js: "template/accordion/accordion-group.html"
                if (!~url.indexOf('template/')) {
                    // Append ?v=[cacheBustVersion] to url
                    url += (url.indexOf("?") === -1 ? "?" : "&");
                    url += "v=" + cacheBustVersion;
                }
                return get(url, config);
            };
            return $delegate;
        }]);
     }]);

    angular.module('benepleApp', deps).config(config).run(run);
}

/**
 * IMPORTS
 */

import './global/_module';

import './admin/_module';
import './assets/_module';
import './announcement/_module';
import './calendar/_module';
import './employee/_module';
import './organisation/_module';
import './process/_module';
import './schemaForm/_module';
import './upload/_module';




// WEBPACK FOOTER //
// ./frontend/scripts/app.ts